<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <header class="alb">
      <div class="logo" @click="scrollToTop">
        <img src="../assets/logo.png"/>
        <img src="../assets/logorec.png"/>
      </div>
      <div class="contact">
        <!-- <a href="tel://15216730815">{{ $t('common.call')}}15216730815</a> -->
        <button class="language-button" @click="changeLang"> <span class="iconfont icon-yuyanqiehuan"></span>{{$t('common.lang')}}</button>
      </div>
    </header>
</template>
<script>
export default {
  methods: {
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    changeLang () {
      if (this.$i18n.locale === 'en') { this.$i18n.locale = 'zh' } else { this.$i18n.locale = 'en' }
    }
  }
}
</script>
<style>
  header{width: 100%;height: 60px;padding: 5px 10%;position: fixed;top: 0;left: 0;background-color:rgba(255, 255, 255, 0.8);z-index: 999;}
  .logo{width: 120px;display: flex;justify-content: center;align-items: center;}

  .logo img {width: 50px;}
  .logo img:last-child{width: 70px;}
  .contact{display: flex;justify-content: center;align-items: center;}
  .contact .language-button{margin-left: 5px; min-width: 62px;height: 38px;padding: 0 10px;background: #fff;border:1px solid rgba(0, 0, 0, 0.1); border-radius: 8px;color: #0A0A0A;cursor: pointer;}
  .language-button .iconfont{margin-right: 3px;}
  @media (max-width: 800px) {
    header{width: 100%;height: 60px;padding: 5px 3%;}
    .contact .language-button{min-width: 56px;padding: 0 7px;}
  }
</style>
